var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChekboxActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1689 2.83405V19.1674H2.83553V2.83405H19.1689V2.83405ZM19.1667 0.500122H2.83333C1.55 0.500122 0.5 1.55012 0.5 2.83346V19.1668C0.5 20.4501 1.55 21.5001 2.83333 21.5001H19.1667C20.45 21.5001 21.5 20.4501 21.5 19.1668V2.83346C21.5 1.55012 20.45 0.500122 19.1667 0.500122Z",
    fill: "#E9BE5C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5625,
    y: 1.56384,
    width: 18.2554,
    height: 18.2554,
    fill: "#E9BE5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12891 11.0277L9.46224 14.2944L16.6289 6.12769",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChekboxActive);
export default __webpack_public_path__ + "static/media/chekbox-active.860bac9c1e8633b742c182ba3ae0ad9e.svg";
export { ForwardRef as ReactComponent };